import Vue from 'vue';
import vuescroll from 'vuescroll';
import VTooltip from 'vue-directive-tooltip';
import Toasted from 'vue-toasted';
import VModal from 'vue-js-modal';
import VueLazyload from 'vue-lazyload';
import VueMeta from 'vue-meta';
import VueSimpleContextMenu from 'vue-simple-context-menu';
import * as TgsPlayer from '@lottiefiles/lottie-player/dist/tgs-player';
import LogRocket from 'logrocket';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './i18n';
import apolloProvider from './apollo';
import mixins from './mixins';
import './registerServiceWorker';
import { filesize, truncate } from './filters';

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_LOGROCKET) {
  LogRocket.init('2ncyts/hey-chat');
}

Vue.use(TgsPlayer);

Vue.component('vue-simple-context-menu', VueSimpleContextMenu);

Vue.use(VueMeta);

Vue.use(VueLazyload, {
  attempt: 2,
});

Vue.use(vuescroll, {
  ops: {
    bar: {
      size: '4px',
      minSize: 0.2,
      opacity: 0.6,
      keepShow: true,
      background: '#797979',
      specifyBorderRadius: '0',
    },
    rail: {
      size: '4px',
      gutterOfSide: '0',
      specifyBorderRadius: '0',
    },
    scrollPanel: {
      scrollingX: false,
      easing: 'easeInOutQuad',
    },
  },
});

// Modals
Vue.use(VModal, { dialog: true });

// Tooltip
Vue.use(VTooltip);

// Toast Alerts
Vue.use(Toasted);

const toastOptions = {
  duration: 3000,
  keepOnHover: true,
};

Vue.toasted.register('info', (payload) => payload, {
  type: 'info', icon: 'info', ...toastOptions,
});
Vue.toasted.register('success', (payload) => payload, {
  type: 'success', icon: 'check_circle', ...toastOptions,
});
Vue.toasted.register('error', (payload) => payload, {
  type: 'error', icon: 'cancel', ...toastOptions,
});

Vue.config.productionTip = false;

Vue.mixin(mixins);
Vue.filter('filesize', filesize);
Vue.filter('truncate', truncate);

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: (h) => h(App),
  beforeCreate() { this.$store.commit('setTheme'); },
}).$mount('#app');
